import { image2Canvas } from '@meitu/saas-editor-core/es/utils/file-kit';
import { UploadImage } from '../../upload-model/type';
import { transformCanvasToFile } from '../../upload-model/utils';

export const imgFileToCanvas = (file: File): Promise<HTMLCanvasElement> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = function (e) {
            const img = new Image();
            img.onload = function () {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');

                // Set canvas dimensions to the image dimensions
                canvas.width = img.width;
                canvas.height = img.height;
                ctx?.drawImage(img, 0, 0);
                resolve(canvas);
            };

            img.onerror = function (e) {
                console.log(e);
                reject(e);
            };

            if (!e.target) {
                console.log('图片文件加载失败');
                reject();
            } else {
                img.src = e.target?.result as string;
            }
        };
        reader.readAsDataURL(file);
    });
};

/**
 *
 * @param psd psd json 源数据
 * @param uploadFn 上传图片回调函数
 */
export const getUrlByImageElement = async (
    name: string,
    img: HTMLImageElement,
    uploadFn: UploadImage,
    imageType = 'image/png',
) => {
    const canvas = await image2Canvas(img, img.width, img.height, img.width, img.height);
    const url = await uploadFn(transformCanvasToFile(name, canvas, imageType));

    return url;
};

export const getSvgUrl = async (svgString: string, uploadFile: UploadImage) => {
    const svgBlob = new Blob([svgString], { type: 'image/svg+xml' });
    const { type } = svgBlob;
    const file = new File([svgBlob], '自定义图片', { type });
    const url = await uploadFile(file, 'svg');
    return url;
};
